<template>
    <nav class="wa-doc_render_toc relative sm:block">
        <div class="wa-doc_render_toc__title">
            <p class="m-0">Table of Contents</p>
        </div>
        <hr class="mb-6 mt-4 h-[1px] w-full bg-[#dedede]" />
        <ul class="wa-doc_render_toc__content mb-5 space-y-0">
            <TopItem v-for="item of toc2" :key="item.id" class="!my-0" :item="item" :active="active"></TopItem>
        </ul>
    </nav>
</template>

<script lang="ts" setup>
import TopItem from "./TopItem.vue";

const props = defineProps<{
    toc: {
        id: string;
        depth: "1" | "2" | "3" | "4" | "5";
        text: string;
    }[];
    active?: string;
}>();
const toc2 = computed(() => {
    return props.toc.filter((item) => item.depth === "2");
});
</script>

<style lang="scss">
@include b(doc_render_toc) {
    @apply w-auto  p-8 pb-2;
    @apply rounded bg-slate-50 shadow-sm;
    &__title {
        @apply mb-2 text-base font-medium xl:text-2xl;
    }

    &::before {
        // content: "";
        // display: block;
        // border-bottom: 4px solid #f25929;
        // margin: -32px -32px 32px;
    }
}
</style>
